import React from "react";
import { CssBaseline, Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import AppTheme from "../../themes/sharedThemes";
import { dataGridCustomizations } from "../../themes/customizations/dataGrid";
import { useIsTablet } from "@hooks/use-is-tablet";
import Pic from "../../assets/pic.webp";

const xThemeComponents = {
  ...dataGridCustomizations,
};

const Auth = ({ children }: { children?: React.ReactNode }) => {
  const isTablet = useIsTablet();

  return (
    <AppTheme themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box
        sx={{
          display: "flex",
          height: "100vh",
        }}
      >
        <Box
          sx={{
            flex: isTablet ? "1" : "0 0 55%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {children || <Outlet />}
        </Box>
        {!isTablet && (
          <Box
            sx={{
              flex: "0 0 45%",
              backgroundImage: `url(${Pic})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
        )}
      </Box>
    </AppTheme>
  );
};

export default Auth;
